import { a as assignGlobalSingleton } from "../global-33d5eebf.js";
import { b as baseEnums } from "../enums-86f58524.js";
const enums = assignGlobalSingleton("enums", () => ({
  ...baseEnums
}));
const addEnums = (enumsToRegister) => {
  for (const name in enumsToRegister) {
    enums[name] = enumsToRegister[name];
  }
};
const getEnum = (name) => {
  return enums[name];
};
export {
  addEnums,
  getEnum
};
//# sourceMappingURL=index.js.map
